// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-1UVZXUjB","dbox":"dbox-3tGR_nHz"};